import { Backdrop, Box, styled } from '@/shared/ui';

import { LoaderProps } from './types';

export const StyledBackdrop = styled(Backdrop)(() => ({
  backdropFilter: 'blur(5px)',
  WebkitBackdropFilter: 'blur(5px)',
  backgroundColor: '#FFFFFF33',
}));

export const StyledContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'containerSize',
})<LoaderProps>(({ containerSize }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',

  ...(containerSize === 'auto' && {
    height: '100%',
  }),

  ...(containerSize === 'extraSmall' && {
    height: '150px',
  }),

  ...(containerSize === 'small' && {
    height: '300px',
  }),

  ...(containerSize === 'medium' && {
    height: '600px',
  }),

  ...(containerSize === 'large' && {
    height: '100vh',
  }),
}));
